import { BaseTypeaheadItem } from '../../../../shared/views/typeaheads';

export const EquipmentTypeaheadItem = BaseTypeaheadItem.extend({
    template: '#tpl_sensor_equipment_typeahead_item',
    className: 'equipment_typeahead_item',

    formatTitle: function (model) {
        const titleList = [];

        if (model.get('equipment')) titleList.push(model.get('equipment').get('model_name'));

        if (model.get('location_zone')) titleList.push(model.get('location_zone'));

        return titleList.join(' - ');
    },

    formatSubtitle: function (model) {
        if (model.get('identifier')) return model.get('identifier');

        return '';
    },

    templateHelpers: function () {
        return {
            title: this.formatTitle(this.model),
            show_checkmark: this.show_checkmark,
            is_checked: this.model.is_checked,
            subtitle: this.formatSubtitle(this.model)
        };
    }
});
